function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.71711 0 0 .68002 19.236 20.351)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polygon", {
  points: "67.583 122.98 14.097 122.98 4.083 111.56 4.083 16.009 14.097 4.582 67.583 4.582 77.598 16.009 77.598 111.56"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.097,
  x2: 23.993,
  y1: 4.699,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.083,
  x2: 19.398,
  y1: 15.891,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  x1: 67.583,
  x2: 57.688,
  y1: 4.699,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  x1: 77.598,
  x2: 62.281,
  y1: 15.891,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  x1: 67.583,
  x2: 57.688,
  y1: 122.86,
  y2: 109.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 77.598,
  x2: 62.281,
  y1: 111.67,
  y2: 104.49
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.097,
  x2: 23.993,
  y1: 122.86,
  y2: 109.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.083,
  x2: 19.398,
  y1: 111.67,
  y2: 104.49
}), /*#__PURE__*/React.createElement("polygon", {
  points: "64.167 118.39 17.514 118.39 9.267 109.32 9.267 18.248 17.514 9.176 64.167 9.176 72.413 18.248 72.413 109.32"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "60.984 113.79 20.694 113.79 14.45 106.84 14.45 20.722 20.694 13.771 60.984 13.771 67.229 20.722 67.229 106.84"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "57.688 109.14 23.993 109.14 19.398 104.43 19.398 23.137 23.993 18.424 57.688 18.424 62.281 23.137 62.281 104.43"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.71711 0 0 .68002 86.462 20.104)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polygon", {
  points: "4.083 111.56 4.083 16.009 14.097 4.582 67.583 4.582 77.598 16.009 77.598 111.56 67.583 122.98 14.097 122.98"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.097,
  x2: 23.993,
  y1: 4.699,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.083,
  x2: 19.398,
  y1: 15.891,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  x1: 67.583,
  x2: 57.688,
  y1: 4.699,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  x1: 77.598,
  x2: 62.281,
  y1: 15.891,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  x1: 67.583,
  x2: 57.688,
  y1: 122.86,
  y2: 109.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 77.598,
  x2: 62.281,
  y1: 111.67,
  y2: 104.49
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.097,
  x2: 23.993,
  y1: 122.86,
  y2: 109.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.083,
  x2: 19.398,
  y1: 111.67,
  y2: 104.49
}), /*#__PURE__*/React.createElement("polygon", {
  points: "9.267 109.32 9.267 18.248 17.514 9.176 64.167 9.176 72.413 18.248 72.413 109.32 64.167 118.39 17.514 118.39"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "14.45 106.84 14.45 20.722 20.694 13.771 60.984 13.771 67.229 20.722 67.229 106.84 60.984 113.79 20.694 113.79"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "19.398 104.43 19.398 23.137 23.993 18.424 57.688 18.424 62.281 23.137 62.281 104.43 57.688 109.14 23.993 109.14"
}));

const SvgEmeraldPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 164,
  height: 127,
  enableBackground: "new 0 0 82 127",
  viewBox: "0 0 164 127",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmeraldPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emerald-pair.c6cba994.svg";
export { ForwardRef as ReactComponent };